/* eslint-disable */
export const leaderLinePlugin = (enabled: boolean) => ({
  id: 'leaderLine',
  afterDatasetDraw(chart: any) {
    const { ctx } = chart;
    const dataset = chart.data.datasets[0];
    const backgroundColors = dataset.backgroundColor;
    const meta = chart.getDatasetMeta(0);

    ctx.save();
    ctx.font = 'bold 13px Ubuntu';
    ctx.strokeStyle = '#000';
    ctx.lineWidth = 1;

    const total = dataset.data.reduce((a: number, b: number) => a + b, 0);

    let rightUsed = false;
    let leftUsed = false;

    dataset.data.forEach((value: number, index: number) => {
      const arc = meta.data[index];

      const { startAngle, endAngle, outerRadius, x, y } = arc.getProps(
        ['startAngle', 'endAngle', 'outerRadius', 'x', 'y'],
        true
      );

      const angle = endAngle - startAngle;
      const degree = angle * (180 / Math.PI);

      if (enabled) {
        if (degree < 20) {
          const mid = startAngle + angle / 2;

          // логіка праворуч / ліворуч
          let isRight;
          if (Math.cos(mid) > 0) {
            isRight = !rightUsed;
            rightUsed = true;
          } else {
            isRight = false;
            if (leftUsed) isRight = true;
            else leftUsed = true;
          }

          const p1x = x + Math.cos(mid) * outerRadius;
          const p1y = y + Math.sin(mid) * outerRadius;

          const p2x = x + Math.cos(mid) * (outerRadius + 15);
          const p2y = y + Math.sin(mid) * (outerRadius + 15);

          const p3x = p2x + (isRight ? 30 : -30);

          // малюємо лінію
          ctx.beginPath();
          ctx.moveTo(p1x, p1y);
          ctx.lineTo(p2x, p2y);
          ctx.lineTo(p3x, p2y);
          ctx.stroke();

          // колір тексту = колір сектора
          const sectorColor = Array.isArray(backgroundColors)
            ? backgroundColors[index]
            : '#000';

          ctx.fillStyle = sectorColor;
          ctx.textAlign = isRight ? 'left' : 'right';
          ctx.textBaseline = 'middle';

          const percent = ((value / total) * 100).toFixed(1) + '%';

          ctx.fillText(percent, p3x + (isRight ? 4 : -4), p2y);
        }
      }
    });

    ctx.restore();
  }
});

export const optionsPieChart = (isCustomerReport: boolean): any => {
  return {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          font: { family: 'Ubuntu-Regular', size: 13 },
          usePointStyle: true,
          pointStyle: 'circle',
          boxHeight: 5,
          boxWidth: 5
        }
      },
      title: {
        display: true,
        text: 'General Satisfaction',
        align: 'start',
        color: '#1B242D',
        font: { family: 'Ubuntu-Regular', size: 16, weight: '600' }
      },
      datalabels: isCustomerReport
        ? {
            color: '#fff',
            font: { weight: 'bold', size: 14 },

            display: (ctx: any) => {
              const arc = ctx.chart.getDatasetMeta(0).data[ctx.dataIndex];
              const angle = (arc.endAngle - arc.startAngle) * (180 / Math.PI);
              return angle >= 20;
            },

            anchor: 'center',
            align: 'center',

            formatter: (value: any, context: any) => {
              const data = context.chart.data.datasets[0].data as number[];
              const total = data.reduce((a, b) => a + b, 0);
              return `${((value / total) * 100).toFixed(1)}%`;
            }
          }
        : {
            display: false
          }
    }
  };
};
